<template>
    <div>
        <top-header :type="6" :placeholder="'排行榜'" :bgColor="'#fff'" fontSize="0.32rem"/>
        <div class="top_banner">
            <img src="@/assets/img/top4.jpg" alt="">
        </div>
        <div class="line_"></div>
        <div class="pad_t" v-show="showPad"></div>
        <div class="tab_con m_flex_box" :class="showPad ? 'fixed' : ''">
            <span :class="current === 1 ? 'active' : ''" @click="changeType(1)">二手小区热卖楼盘</span>
            <span :class="current === 2 ? 'active' : ''" @click="changeType(2)">二手小区热卖成交</span>
        </div>
        <div class="list">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                >
                    <div class="no_data" v-if="!list.length">
                        <img src="@/assets/img/nodata.png" alt="">
                    </div>
                    <div class="list_con new_list">
                        <div class="inner m_flex_box flex_vc" v-for="(item, index) in list" :key="index"
                             @click="toDetail(item.id,item.old)">
                            <div class="banner_con">
                                <img class="banner" v-lazy="imgPath + 'sImgMin/' + item.xmfm + '.jpg'">
                                <p class="rank" :class="index < 3 ? 'before' : ''">top{{index + 1}}</p>
                            </div>
                            <div class="new_r">
                                <p class="col_gold">{{current === 1 ? '累计挂牌' : '成交'}}套数 <span v-show="current==1">{{item.csts}}</span>
                                    <span v-show="current==2">{{item.cjts}}</span></p>
                                <div class="m_flex_box flex_vc flex_jz tit">
                                    <h4 class="line_comp1">{{item.tgmc}}</h4>
                                </div>
                                <!-- 项目名称 -->
                                <p class="line_comp1 col_gray">{{item.xmmc}}</p>
                                <p class="line_comp1 col_gray">{{item.xmdz ? item.xmdz : '暂无地址信息'}}</p>
                            </div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
        <slide-img></slide-img>
    </div>
</template>

<script>
    import qs from 'qs'
    import topHeader from '@/components/header'
    import slideImg from '@/components/slideImg'
    export default {
        name: 'RankOld',
        data() {
            return {
                current: 1,
                isLoading: false,
                loading: false,
                finished: false,
                showPad: false,
                list: [],
                timer: null,
                offsetTop: 0,
            };
        },
        components: {
            topHeader,
            slideImg
        },
        mounted() {
            this.onLoad();
            this.offsetTop = document.querySelector('.line_').offsetTop;
            window.addEventListener('scroll', this.handleScroll)
        },
        methods: {
            changeType(type) {
                this.current = type;
                this.loading = false;
                this.finished = false;
                this.$set(this, 'list', []);
                this.onLoad()
            },
            onRefresh() {
                this.loading = false;
                this.finished = false;
                this.$set(this, 'list', []);
                this.onLoad(1)
            },
            toDetail(itemId, old) {
                var path = '/projectDetail';
                if (old == 1) {
                    path = '/projectDetailIndex';
                }
                this.$router.push({
                    path: path,
                    query: {itemId}
                })
            },
            onLoad(type) {
                var url_ = '';
                if (this.current == 1) {
                    url_ = 'cms/houseListed/permit/getHotSale.do';
                } else {
                    url_ = 'cms/houseListed/permit/getHotSign.do';
                }
                if (!this.timer) {
                    this.timer = setTimeout(() => {
                        this.timer = null;
                    }, 50)
                    this.$http.post(url_, qs.stringify({
                        area: this.main.getHostArea(),
                    })).then(res => {
                        if (type) {
                            this.isLoading = false;
                        }
                        if (res.success) {
                            this.loading = false;
                            this.$set(this, 'list', res.obj);
                            this.loading = false;
                            this.finished = true;
                        }
                    })
                }
            },
            handleScroll() {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                if (scrollTop > this.offsetTop - (document.documentElement.clientWidth / 7.5) * 0.9) {
                    this.showPad = true
                } else {
                    this.showPad = false
                }
            },
        },
        beforeRouteLeave (to, from, next) {
            if (to.name === 'ProjectDetail' || to.name === 'ProjectDetailIndex'){
            this.$store.dispatch('saveView', ['RankOld']).then(() => {
                next()
            })
            } else {
            this.$store.dispatch('saveView', []).then(() => {
                next()
            })
            }
        },
    };
</script>
<style lang="less" scoped>
    .tab_con {
        height: 0.94rem;
        border-bottom: 1px solid #f5f5f5;
        padding-left: 0.23rem;
        background-color: #fff;
        z-index: 2;

        &.fixed {
            position: fixed;
            top: 0.9rem;
            left: 0;
            right: 0;
        }

        span {
            font-size: 0.32rem;
            color: #202020;
            margin-right: 0.74rem;
            line-height: 0.94rem;
            position: relative;

            &.active {
                font-weight: 800;

                &:after {
                    content: '';
                    display: block;
                    width: 0.48rem;
                    height: 0.04rem;
                    background-color: #2F72F5;
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    margin-left: -0.24rem;
                }
            }
        }
    }

    .top_banner {
        width: 100%;

        img {
            width: 100%;
            height: 3.16rem;
            display: block;
        }
    }

    .pad_t {
        padding-top: 0.94rem;
    }

    .list_con {
        margin: 0.05rem auto 0;
        width: 7.04rem;

        .inner {
            padding: 0.35rem 0;
            border-bottom: 1px solid #F4F4F4;
        }

        .banner_con {
            width: 2.44rem;
            height: 1.84rem;
            position: relative;

            .rank {
                background-color: #404040;
                color: #fff;
                width: 0.8rem;
                line-height: 0.38rem;
                border-radius: 0 0.08rem 0 0.08rem;
                font-size: 0.22rem;
                text-align: center;
                position: absolute;
                top: 0;
                left: 0;
                font-weight: 800;

                &.before {
                    background-color: #24D064;
                }
            }
        }

        .banner {
            width: 2.44rem;
            height: 1.84rem;
            display: block;
        }

        .new_r {
            .col_gold {
                font-size: 0.24rem;
                color: #AF6E20;
                margin-bottom: 0.1rem;
            }

            img {
                width: 100%;
            }

            width: 4.25rem;
            margin-left: 0.3rem;

            .col_gray {
                font-size: 0.24rem;
                color: #505050;
            }

            .tit {
                h4 {
                    font-size: 0.36rem;
                    color: #101010;
                    font-weight: 800;
                    width: 3rem;
                }

                i {
                    //width: 0.6rem;
                    padding: 0 0.04rem;
                    line-height: 0.34rem;
                    color: #2F72F5;
                    font-size: 0.24rem;
                    text-align: center;
                    border: 1px solid currentColor;
                    box-sizing: border-box;
                    border-radius: 0.02rem;
                }

                span {
                    width: 0.6rem;
                    height: 0.34rem;
                    text-align: center;
                    line-height: 0.34rem;
                    color: #fff;
                    background-color: #24D064;
                    font-size: 0.24rem;
                    border-radius: 0.02rem;
                }
            }
        }
    }

    .new_list {
        .inner {
            .new_r {
                .col_gray {
                    margin: 0.1rem 0;
                }

                .info {
                    color: #505050;
                    font-size: 0.24rem;

                    p {
                        margin-right: 0.2rem;
                    }

                    span {
                        color: #FF6A18;
                    }
                }

                .col_red {
                    margin-top: 0.1rem;

                    h4 {
                        font-size: 0.36rem;
                        font-weight: 800;
                    }

                    span {
                        font-size: 0.22rem;
                    }
                }

                .text {
                    margin-top: 0.1rem;
                    font-size: 0.22rem;
                    color: #A0A0A0;

                    i {
                        font-size: 0.18rem;
                    }
                }

                .tel {
                    width: 0.36rem;
                    height: 0.36rem;
                }
            }
        }
    }
</style>